import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPlaylist: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="playlist"><path d="M2.75 5.75H16.26M2.75 12H11.25M2.75 18.25H9.25M21.2539 4.75V16M21.2539 16.75C21.2539 18.1307 19.9108 19.25 18.2539 19.25C16.5971 19.25 15.2539 18.1307 15.2539 16.75C15.2539 15.3693 16.5971 14.25 18.2539 14.25C19.9108 14.25 21.2539 15.3693 21.2539 16.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconPlaylist;
